import { FC } from 'react';
import cn from 'classnames';
import styles from './index.module.less';
import { HeaderNav } from './HeaderNav';
import { HeaderWidgets } from './HeaderWidgets';
import { StickyHeader } from '@base/lib/StickyHeader';
import { HeaderLogo } from '@pro/common/HeaderLogo';

export type IPageHeaderProps = {
    sticky?: boolean;
};

function Main(): Globals.JSXRenderType {
    return (
        <div className={cn('wrapper flex flex-middle')}>
            <HeaderLogo size={270}/>
            <HeaderNav/>
            <HeaderWidgets/>
        </div>
    )
}

export const PageHeader: FC<IPageHeaderProps> = props => {
    const { sticky = true } = props;

    return sticky ? (
        <StickyHeader
            className={styles.header}
            hideWhenDown
        >
            <Main/>
        </StickyHeader>
    ) : (
        <div className={styles.header}>
            <Main/>
        </div>
    )
};
